/**
 * API endpoints for Root Admin functionality
 * These endpoints are only accessible by super_admin and manager roles
 */
export const ROOT_ADMIN_ENDPOINTS = {
    // Developer management
    INVITE_DEVELOPER: '/root-admin/invite-developer',
    LIST_DEVELOPERS: '/root-admin/developers',
    
    // Manager management
    INVITE_MANAGER: '/root-admin/invite-manager',
    LIST_MANAGERS: '/root-admin/managers',
    
    // User verification
    VERIFY_USER: '/root-admin/verify',
    
    // User management
    DELETE_USER: (userId: string) => `/root-admin/users/${userId}/delete`,
    
    // Access grants
    GRANT_ACCESS: (userId: string) => `/root-admin/users/${userId}/grant-access`,
    REVOKE_ACCESS: (userId: string, organizationId: string) => 
        `/root-admin/users/${userId}/revoke-access/${organizationId}`,
    LIST_USER_ACCESS_GRANTS: (userId: string) => `/root-admin/users/${userId}/access-grants`,
    
    // Pending invitations
    LIST_PENDING_INVITATIONS: '/root-admin/pending-invitations',
    CANCEL_INVITATION: (invitationId: string) => `/root-admin/pending-invitations/${invitationId}`,
} as const;

/**
 * Root user roles
 */
export const ROOT_USER_ROLES = {
    SUPER_ADMIN: 'super_admin',
    MANAGER: 'manager',
    DEVELOPER: 'developer',
} as const;

/**
 * Roles that can access root admin endpoints
 */
export const ROOT_ADMIN_ALLOWED_ROLES = ['super_admin', 'manager'] as const;

/**
 * Check if a user role can access root admin features
 */
export const canAccessRootAdmin = (role: string): boolean => {
    return ROOT_ADMIN_ALLOWED_ROLES.includes(role as typeof ROOT_ADMIN_ALLOWED_ROLES[number]);
};
